import logo from '../../wootic_logo.jpg';

const LogoIcon = () => (
  <img
    src={logo}
    alt="WOOTIC"
    style={{ height: 32, width: 32, borderRadius: 6, objectFit: 'cover' }}
  />
);

export default LogoIcon;
